import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 16l6 -7l5 5l5 -6","key":"svg-0"}],["path",{"d":"M14 14a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M9 9a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-2"}],["path",{"d":"M3 16a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-3"}],["path",{"d":"M19 8a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-4"}]]

const IconTimeline = createReactComponent('outline', 'timeline', 'Timeline', __iconNode);

export default IconTimeline;